/** Registro del consentimiento informado para cookies / almacenamiento local (primera capa legal). */
export const COOKIE_CONSENT_STORAGE_KEY = 'orgcloud_cookie_consent_v1';

export type CookieConsentRecord = {
  v: 1;
  accepted: true;
  t: number;
};

export function hasCookieConsentRecorded(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as Partial<CookieConsentRecord>;
    return parsed?.v === 1 && parsed?.accepted === true;
  } catch {
    return false;
  }
}

export function recordCookieConsent(): void {
  if (typeof window === 'undefined') return;
  try {
    const payload: CookieConsentRecord = { v: 1, accepted: true, t: Date.now() };
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* noop */
  }
}
